import { EventBus } from './../../../shared/services/event-bus/event-bus';
import { InitializePusher } from './../../../store/actions/pusher-actions';
import { PusherService } from './../../../shared/services/pusher/pusher-service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ENTITY_TYPE } from 'Src/ng2/shared/typings/types/entity-type.types';
import { UrlNavigationService } from 'Src/ng2/shared/services/url-navigation/url-navigation.service';

@Injectable()
export class PusherResolver implements Resolve<any> {
  constructor (
    private pusherService: PusherService,
    private eventBus: EventBus,
  ) {}

  resolve (route: ActivatedRouteSnapshot): Observable<any> {
    const entityType = UrlNavigationService.getEntityType(route);
    const entityId = UrlNavigationService.getEntityId(route);
    // This resolver is only meant to run on entity-type school
    if (entityType && entityType !== ENTITY_TYPE.SCHOOL) return of({});

    this.pusherService.ensureUnsubscribeFromPrevSchools(entityId);
    const channel = this.pusherService.getCurrentSchoolChannel(entityId);

    const action = new InitializePusher(channel);
    this.eventBus.emitAction(action);

    return of(channel);
  }
}
